import { styled } from 'styled-components';

import { navigationTransitionCss } from '#/theme/navigationTransitionCss';

export const LayoutHolder = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  @media print {
    min-height: unset;
  }
`;

export const LayoutChildrenHolder = styled.div`
  flex: 1;
  position: relative;

  ${navigationTransitionCss};
`;

export const LayoutBaseVariantProgressBarHolder = styled.div`
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
`;
